/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { SetDefaultStoreRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { SetDefaultStoreResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DefaultStoreSetApi - axios parameter creator
 * @export
 */
export const DefaultStoreSetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * set the default store for a guest/registered user
         * @summary set the default store for a guest/registered user
         * @param {string} storeId The store identifier.
         * @param {SetDefaultStoreRequest} setDefaultStoreRequest The request object for setting the default store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultStoreSet: async (storeId: string, setDefaultStoreRequest: SetDefaultStoreRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('defaultStoreSet', 'storeId', storeId)
            // verify required parameter 'setDefaultStoreRequest' is not null or undefined
            assertParamExists('defaultStoreSet', 'setDefaultStoreRequest', setDefaultStoreRequest)
            const localVarPath = `/store/{storeId}/SelectStore/setDefaultStore`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setDefaultStoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultStoreSetApi - functional programming interface
 * @export
 */
export const DefaultStoreSetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultStoreSetApiAxiosParamCreator(configuration)
    return {
        /**
         * set the default store for a guest/registered user
         * @summary set the default store for a guest/registered user
         * @param {string} storeId The store identifier.
         * @param {SetDefaultStoreRequest} setDefaultStoreRequest The request object for setting the default store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async defaultStoreSet(storeId: string, setDefaultStoreRequest: SetDefaultStoreRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetDefaultStoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.defaultStoreSet(storeId, setDefaultStoreRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultStoreSetApi - factory interface
 * @export
 */
export const DefaultStoreSetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultStoreSetApiFp(configuration)
    return {
        /**
         * set the default store for a guest/registered user
         * @summary set the default store for a guest/registered user
         * @param {string} storeId The store identifier.
         * @param {SetDefaultStoreRequest} setDefaultStoreRequest The request object for setting the default store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultStoreSet(storeId: string, setDefaultStoreRequest: SetDefaultStoreRequest, options?: any): AxiosPromise<SetDefaultStoreResponse> {
            return localVarFp.defaultStoreSet(storeId, setDefaultStoreRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultStoreSetApi - object-oriented interface
 * @export
 * @class DefaultStoreSetApi
 * @extends {BaseAPI}
 */
export class DefaultStoreSetApi extends BaseAPI {
    /**
     * set the default store for a guest/registered user
     * @summary set the default store for a guest/registered user
     * @param {string} storeId The store identifier.
     * @param {SetDefaultStoreRequest} setDefaultStoreRequest The request object for setting the default store.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultStoreSetApi
     */
    public defaultStoreSet(storeId: string, setDefaultStoreRequest: SetDefaultStoreRequest, options?: any) {
        return DefaultStoreSetApiFp(this.configuration).defaultStoreSet(storeId, setDefaultStoreRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
